"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    ref: "content",
    staticClass: "aboutus-con",
    attrs: {
      id: "aboutus"
    }
  }, [_c("div", {
    staticClass: "aboutus-banner"
  }, [_c("img", {
    staticClass: "height-516",
    attrs: {
      src: require("../../assets/static/img/aboutus/banner-01.jpg")
    }
  }), _c("div", {
    ref: "datum",
    staticClass: "datum flex-row-center"
  }, [_c("div", {
    staticClass: "felx-row-between width-1280"
  }, _vm._l(_vm.companyData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "text-center flex-col-center"
    }, [_c("div", {
      staticClass: "font-36 color-2A559D"
    }, [_vm._v(_vm._s(item.num))]), _c("div", {
      staticClass: "font-16 color-555555"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)])]), _c("div", {
    staticClass: "aboutus-main"
  }, [_c("div", {
    ref: "introduce",
    staticClass: "introduce flex-row-center"
  }, [_c("img", {
    staticClass: "introduce-img",
    attrs: {
      src: require("../../assets/static/img/aboutus/01.jpg"),
      alt: ""
    }
  }), _vm._m(0)]), _c("div", {
    ref: "culture",
    staticClass: "culture flex-row-center align-item-start"
  }, [_vm._m(1), _vm._m(2)]), _c("div", {
    ref: "honor",
    staticClass: "honor"
  }, [_vm._m(3), _c("div", {
    staticClass: "main-item"
  }, [_c("swiper", {
    attrs: {
      listData: _vm.honorList
    }
  })], 1)]), _c("div", {
    ref: "company",
    staticClass: "cooperative"
  }, [_vm._m(4), _vm._m(5)]), _c("div", {
    staticClass: "recruit"
  }, [_c("div", {
    staticClass: "main-item flex-row-sb align-item-center"
  }, [_c("div", {
    staticClass: "text-left"
  }, [_c("div", {
    staticClass: "font-36 font-weight-500 color-white"
  }, [_vm._v("招贤纳士")]), _c("div", {
    staticClass: "color-white font-16 margin-top-30 line-height-20"
  }, [_vm._v(" 我们有运营、有产品、有技术、有市场推广等部门，你在其他互联网公司所掌握的技能在这里不用担心没有用武之地，你想学习的互联网知识技能也都有前辈指导！至于行业知识？不用担心上手难度，人生难免会有第一次，你要做的是和公司一起成长！ ")]), _c("div", {
    staticClass: "more-btn font-14",
    on: {
      click: _vm.toPage
    }
  }, [_vm._v("了解更多")])]), _c("img", {
    staticClass: "recruit-img",
    attrs: {
      src: require("../../assets/static/img/aboutus/14.jpg"),
      alt: ""
    }
  })])]), _c("div", {
    ref: "contact",
    staticClass: "contact"
  }, [_c("div", {
    staticClass: "contact-main"
  }, [_c("div", {
    staticClass: "contact-txt text-align-left"
  }, [_vm._m(6), _vm._m(7), _c("div", {
    staticClass: "contact-address"
  }, [_c("p", {
    staticClass: "font-12"
  }, [_vm._v("电话：" + _vm._s(_vm.$root.ptTel))]), _c("p", {
    staticClass: "font-12"
  }, [_vm._v("邮箱：1436898740@qq.com")]), _c("p", {
    staticClass: "font-12"
  }, [_vm._v("QQ：1436898740")]), _c("p", {
    staticClass: "font-12"
  }, [_vm._v("地址(厦门)：厦门市湖里区华美创意空间C1楼5N")]), _c("p", {
    staticClass: "font-12"
  }, [_vm._v("地址(漳州)：芗城区新华北路33号嘉华大厦三楼")])])]), _c("img", {
    staticClass: "contact-img",
    attrs: {
      src: require("../../assets/static/img/aboutus/13.jpg"),
      alt: ""
    }
  })])])]), _c("foot-nav")], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "main-item text-left"
  }, [_c("div", {
    staticClass: "font-36 font-weight-500 color-212121"
  }, [_vm._v("公司简介")]), _c("div", {
    staticClass: "color-555555 font-16 margin-top-30 line-height-16"
  }, [_c("p", [_vm._v("漳州市快悠悠供应链管理有限公司是福建快悠悠信息科技有限公司的品牌公司，致力研究运输管理系统及仓储管理系统，为危化镖局的信息化、流程化、规范化提供有力的技术支持。")]), _c("p", [_vm._v("福建快悠悠信息科技有限公司是一家专注化工物流行业的交易、物流、仓储以及线上线下延伸服务的专业解决方案供应商。")]), _c("p", [_vm._v("“危化镖局”作为化工供应链一站式综合信息服务平台，以化工行业独有的物流管理系统、仓储管理系统，一站式交易＆信息平台三大主体功能，专业为化工企业、货运司机以及下游工厂提供一站式综合供应链服务。致力于建立辐射全国的危化配送网络，搭建信息共享平台，形成全国统一服务标准，为有资质用户提供撮合等信息合作。 ")]), _c("p", [_vm._v("福建快悠悠信息科技有限公司专注解决化工供应链中的痛点问题，推出各项行业产品以提供信息化、数据化、流程化、规范化等服务，着手打破三大市场的信息孤岛，以提供整体化供应链解决方案。")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-left"
  }, [_c("div", {
    staticClass: "color-212121 font-36"
  }, [_vm._v("公司理念")]), _c("div", {
    staticClass: "font-18 color-666666"
  }, [_vm._v("Company philosophy")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "main-item"
  }, [_c("div", {
    staticClass: "flex-row-start text-left align-item-start"
  }, [_c("span", {
    staticClass: "font-20 color-777777 width-120"
  }, [_vm._v("企业使命")]), _c("span", {
    staticClass: "font-20 color-212121 width-640"
  }, [_vm._v("整合化工产业资源，以数智化驱动供应链协同与价值提升;")])]), _c("div", {
    staticClass: "flex-row-start text-left align-item-start"
  }, [_c("span", {
    staticClass: "font-20 color-777777 width-120"
  }, [_vm._v("企业愿景")]), _c("span", {
    staticClass: "font-20 color-212121 width-640"
  }, [_vm._v("成为化工产业数字化生态的共建者与首选成长平台；")])]), _c("div", {
    staticClass: "flex-row-start text-left align-item-start"
  }, [_c("span", {
    staticClass: "font-20 color-777777 width-120"
  }, [_vm._v("核心价值观")]), _c("span", {
    staticClass: "font-20 color-212121 width-640"
  }, [_c("p", [_vm._v("安全为基、合规为纲、数据驱动、协同共生、务实创新")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "color-212121 font-36 text-align-center"
  }, [_c("div", [_vm._v("公司荣誉")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "color-212121 font-36 text-align-center",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c("div", [_vm._v("合作企业")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content flex-row-center image-grid"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E2D\u56FD\u6D82\u6599\u534F\u4F1A.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E2D\u56FD\u7269\u6D41\u4E0E\u91C7\u8D2D\u8054\u5408\u4F1A.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u56FD\u5BB6\u77F3\u6CB9\u548C\u5316\u5DE5\u7F51.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E2D\u56FD\u4EA4\u901A\u8FD0\u8F93\u534F\u4F1A.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5B9D\u6B66\u78B3\u94A2.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5316\u5DE5\u5B9D.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u798F\u5EFA\u8054\u5408\u77F3\u6CB9\u5316\u5DE5.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u6E56\u5317\u5B9C\u5316.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u7ACB\u90A6.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5DF4\u5FB7\u5BCC.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u6E58\u6C5F\u6D82\u6599.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u541B\u5B50\u5170\u6F06.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u7D2B\u8346\u82B1\u6F06.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5927\u660C\u6811\u8102.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u534E\u878D\u5316\u5B66.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u65B0\u5E0C\u671B\u96C6\u56E2.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5174\u53D1.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u56FD\u98CE\u65B0\u6750.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E07\u534E\u5316\u5DE5.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E09\u6728\u96C6\u56E2.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u91D1\u71D5.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u7EA2\u5B9D\u4E3D.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4E91\u5929\u5316\u96C6\u56E2.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u798F\u5316\u96C6\u56E2.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u4F18\u8010\u5FB7.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u65B0\u7586\u6709\u8272.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u5B81\u5FB7\u65F6\u4EE3.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u56FD\u8F69\u79D1\u6280.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u6BD4\u4E9A\u8FEA.png")
    }
  }), _c("img", {
    attrs: {
      src: require("../../assets/static/img/cooperate/\u591A\u6C1F\u591A.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "contact-title"
  }, [_c("p", {
    staticClass: "font-30 text-white font-weight-500"
  }, [_vm._v("联系我们")]), _c("p", {
    staticClass: "font-14 margin-top-10",
    staticStyle: {
      color: "#909399"
    }
  }, [_vm._v("CONTACT US")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "contact-company"
  }, [_c("p", {
    staticClass: "font-16"
  }, [_vm._v("漳州市快悠悠供应链管理有限公司")]), _c("p", {
    staticClass: "font-16"
  }, [_vm._v("福建快悠悠信息科技有限公司")])]);
}];
render._withStripped = true;